/**
 * Feed Processing Feature Routes
 */
import type { RouteRecordRaw } from 'vue-router';
import i18next from 'i18next';

export const feedProcessingRoutes: RouteRecordRaw[] = [
  {
    path: '/feed-processing',
    name: 'feed-processing',
    component: () => import('./views/FeedProcessingListView.vue'),
    meta: {
      title: () => i18next.t('nav.feedProcessing'),
      requiredAnyEntitlement: ['feed.feed_prep_full', 'feed.feed_prep_donor_only', 'feed.feed_prep_product', 'feed.feed_prep_donor_mother'],
      breadcrumbs: [{ label: () => i18next.t('nav.feedProcessing') }],
    },
  },
  {
    path: '/feed-processing/prepare',
    name: 'feed-prepare',
    component: () => import('./views/PrepareFeedView.vue'),
    meta: {
      title: () => i18next.t('feed.prepareFeed'),
      requiredAnyEntitlement: ['feed.feed_prep_full', 'feed.feed_prep_donor_only', 'feed.feed_prep_product', 'feed.feed_prep_donor_mother'],
      breadcrumbs: [{ label: () => i18next.t('nav.feedProcessing'), to: '/feed-processing' }, { label: () => i18next.t('feed.prepareFeed') }],
    },
  },
];
